<template>
  <div class="report_builder">
    <v-container>
      <v-form ref="form" v-model="valid">
        <h2 class="mb-2">
          {{ $store.state.customerName }} 集計・グラフ表示画面 作成
        </h2>
        <p>一覧表示する帳票を設定</p>
        <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
        <v-row>
          <!-- {{ productForms.area }} -->
          <v-col cols="12" sm="9">
            <v-card outlined class="pa-6">
              <v-row justify="center">
                <v-btn @click="modalOpen(2)" color="primary" class="ma-4"
                  >検索フォームの追加</v-btn
                >
              </v-row>
              <v-row justify="center" class="mt-4">
                <v-radio-group
                  label="新規作成ボタン"
                  v-model="productForms.area[0].create"
                  disabled
                  row
                >
                  <v-radio label="有" v-bind:value="true"></v-radio>
                  <v-radio label="無" v-bind:value="false"></v-radio>
                </v-radio-group>
              </v-row>
              <!--
              <v-text-field
                v-model="productForms.area[0].path"
                element="ul"
                label="Path"
                placeholder="集計対象のURL"
                background-color="white"
                outlined
                disabled
              ></v-text-field>
              -->
              <v-row>
                <v-col cols="auto">
                  <v-text-field
                    v-model="productForms.area[0].list_pageID"
                    element="ul"
                    label="ページID"
                    placeholder="一覧表示するページID"
                    background-color="white"
                    outlined
                    :rules="[rules.numonly]"
                  ></v-text-field>
                </v-col>
                <v-col cols="auto">
                  <v-text-field
                    v-model="productForms.area[0].sub_pageID"
                    label="サブページID"
                    placeholder="グラフを出力するサブページID"
                    background-color="white"
                    outlined
                    :rules="[rules.numonly]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center" class="mt-4">
                <v-btn @click="modalOpen(1)" color="primary"
                  >ヘッダー情報</v-btn
                >
              </v-row>
              <v-row justify="center" class="mt-4">
                <v-btn @click="modalOpen(4)" color="primary"
                  >グラフ出力設定</v-btn
                >
              </v-row>
              <v-row justify="center" class="mt-4">
                <v-btn @click="saveForm()" color="primary">SAVE</v-btn>
              </v-row>
              <!--  ヘッダフォーム -->
              <v-dialog v-if="head_dialog" v-model="head_dialog">
                <index-form
                  v-on:clickSubmit="modalClose"
                  :headers="productForms.headers_t"
                  :rules="productForms.area[0].rules"
                  :name="productForms.area[0].name"
                ></index-form>
              </v-dialog>
              <!--  検索フォーム -->
              <v-dialog v-if="search_dialog" v-model="search_dialog">
                <search-form
                  v-on:clickSubmit="modalClose"
                  :searchs="productForms.searchs_t"
                ></search-form>
              </v-dialog>
              <!--  CSV読み込みフォーム 削除する -->
              <!--  グラフ出力設定フォーム -->
              <v-dialog v-if="graph_dialog" v-model="graph_dialog">
                <graph-form
                  v-on:clickSubmit="modalClose"
                  :data="graph_t"
                  :description="desc_t"
                  :page_id="Number(productForms.area[0].list_pageID)"
                ></graph-form>
              </v-dialog>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import indexForm from "../../components/BuilderForm/ReportIndex/IndexForm";
import searchForm from "../../components/BuilderForm/ReportIndex/IndexSearchForm";
import graphForm from "../../components/BuilderForm/ReportIndex/GraphForm";
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  components: {
    indexForm,
    searchForm,
    graphForm,
  },
  data() {
    return {
      //
      head_dialog: false,
      search_dialog: false,
      graph_dialog: false,
      //
      productForms: {
        pageID: null,
        area: [
          {
            type: 5,
            path: null,
            list_pageID: null,
            sub_pageID: null,
            create: false,
            rules: "100",
            headers: [
              [
                { text: "日時", value: 0, align: "start", sortable: true },
                { text: "原因", value: 0 },
                { text: "詳細", value: 0 },
              ],
            ],
          },
        ],
        headers_t: [],
        searchs_t: [],
        delete_area: [],
      },
      desc_t: "",
      graph_t: [],
      //バリデーション
      valid: true,
      rules: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
      },
    };
  },
  async mounted() {
    //初期処理
    await this.getInit();
  },
  methods: {
    async getInit() {
      //初期処理
      this.isLoading = true;
      //page IDとcustomer IDとform情報を送信
      let data = {};
      data.customerID = this.$store.state.customerID;
      data.pageID = Number(this.$route.params.page_id);
      this.productForms.pageID = this.$route.params.page_id;
      this.$store.state.customerID = Number(this.$route.params.id);
      const response = await api.GetForm(data);
      if (response.data[0][0].ID != 0) {
        this.productForms.area = this.respose_convert(response.data[0]);
      }
      //読み込み終了
      this.isLoading = false;
    },
    async saveForm() {
      if (!this.$refs.form.validate()) {
        return;
      }
      let data = {
        area: [this.productForms.area],
        pageID: this.productForms.pageID,
        delete_area: this.productForms.delete_area,
      };
      try {
        data.pageID = await api.RegForm(data, "");
        alert("保存完了");
        this.back();
      } catch (err) {
        alert("送信失敗");
        console.log(err);
      }
    },
    modalOpen: function(value) {
      switch (value) {
        case 1:
          //参照渡しの回避
          this.productForms.headers_t = JSON.parse(
            JSON.stringify(this.productForms.area[0].headers)
          );
          this.head_dialog = true;
          break;
        case 2:
          this.productForms.searchs_t = JSON.parse(
            JSON.stringify(this.productForms.area)
          );
          this.search_dialog = true;
          break;
        case 3:
          /*
            //末尾がCSVダウンロードボタンでない場合
           */
          break;
        case 4:
          //末尾
          if (
            this.productForms.area[this.productForms.area.length - 1].name !=
              "graph" ||
            this.productForms.area[this.productForms.area.length - 1].value ==
              "" ||
            this.productForms.area[this.productForms.area.length - 1].value ==
              null
          ) {
            this.graph_t = {
              value: [],
              rule: [],
            };
            this.desc_t = 22;
          } else {
            this.desc_t = this.productForms.area[
              this.productForms.area.length - 1
            ].description;
            const data = {
              value: this.productForms.area[this.productForms.area.length - 1]
                .value,
              rule: this.productForms.area[this.productForms.area.length - 1]
                .rule,
            };
            this.graph_t = JSON.parse(JSON.stringify(data));
          }
          this.graph_dialog = true;
          break;
      }
    },
    modalClose(param) {
      //headモーダル
      if (this.head_dialog) {
        this.productForms.area[0].headers = JSON.parse(
          JSON.stringify(param.headers)
        );
        this.productForms.area[0].rules = param.rules;
        this.productForms.area[0].name = param.name;
        this.productForms.headers_t = null;
        this.head_dialog = false;
      } else if (this.search_dialog) {
        //serachモーダル
        this.productForms.area = param.searchs;
        this.productForms.delete_area = param.delete_area;
        this.productForms.searchs_t = null;
        this.search_dialog = false;
      } else if (this.graph_dialog) {
        //グラフモーダル 末尾挿入
        let data = {};
        data.name = "graph";
        data.list_pageID = this.productForms.area[0].list_pageID;
        data.value = param.data.grouping;
        (data.type = 5), (data.rule = param.data.counting);
        data.description = param.data.description;
        //末尾にdata挿入
        if (
          this.productForms.area[this.productForms.area.length - 1].name ==
            "graph" ||
          this.productForms.area[this.productForms.area.length - 1].name ==
            "csv"
        ) {
          data.form_id = this.productForms.area[
            this.productForms.area.length - 1
          ].form_id;
          this.productForms.area[this.productForms.area.length - 1] = data;
        } else {
          data.form_id = 0;
          this.productForms.area.push(data);
        }
        this.graph_dialog = false;
      }
    },
    respose_convert: function(data) {
      let area = [];
      data.forEach((value, index) => {
        let tmp = {};
        tmp.form_id = value.ID;
        tmp.name = value.Name;
        console.log("tmp.name", tmp.name);
        tmp.type = 5; //value.Type;
        tmp.path = value.Label;
        tmp.list_pageID = value.Init.split(",")[0];
        tmp.sub_pageID = value.Init.split(",")[1];
        //ヘッダー
        if (index == 0) {
          tmp.headers = JSON.parse(value.Value);
          let arr = value.Rule.split(",");
          if (arr[0] == "true") {
            tmp.create = true;
          } else {
            tmp.create = false;
          }

          tmp.rules = arr.slice(1, arr.length).join(",");
          area.unshift(tmp); //先頭追加
        } else if (value.Name == "") {
          //検索フォーム
          const s = value.Value.split(",");
          tmp.value = s[0];
          tmp.target_id = s[1];
          tmp.color = value.Rule;
          area.push(tmp);
        } else if (value.Name == "graph") {
          //グラフフォーム
          tmp.value = JSON.parse(value.Value);
          tmp.rule = JSON.parse(value.Rule);
          tmp.description = value.Label;
          area.push(tmp);
        }
      });
      return area;
    },
    back() {
      history.back();
    },
  },
};
</script>

<style lang="stylus">
.droparea {
  background: #eee;
  min-height: 30em;
  padding: 1em;
}

/* ボタンの横に×ボタンwの表示するための調整 */
.tmp {
  width: 95%;
  padding: 0.2em;
  background-color: white;
}
</style>
